<script setup>
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
const props = defineProps({
  items: { type: Array, required: true },
  label: { type: String, required: true },
  disabled: Boolean,
});
const emit = defineEmits(['action']);
const open = ref(false);
const root = ref(null);
const trigger = ref(null);
onClickOutside(root, () => {
  open.value = false;
});
function close() {
  open.value = false;
  trigger.value?.$el?.focus();
}
function choose(item) {
  close();
  emit('action', item);
}
</script>

<template>
  <div ref="root" class="relative" @keydown.esc.stop="close">
    <Button
      ref="trigger"
      icon="i-lucide-ellipsis"
      :aria-label="props.label"
      :aria-expanded="open"
      slate
      ghost
      :disabled="disabled"
      @click="open = !open"
    />
    <DropdownMenu
      v-if="open"
      :menu-items="items"
      class="right-0 w-60"
      @action="choose"
    />
  </div>
</template>
